const { getElement } = window.BAO.Utils

function getHeaderHeight () {
  const style = window.getComputedStyle(document.body)
  const announcementBarHeight = parseInt(
    style.getPropertyValue('--AnnouncementBar_Height'),
    10,
  )
  const headerHeight = parseInt(
    style.getPropertyValue('--HeaderBanner_Height'),
    10,
  )

  return `${announcementBarHeight + headerHeight}px`
}

class PinnedContent extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.observer = new IntersectionObserver(
      this.handleObservation.bind(this),
      {
        rootMargin: `-${getHeaderHeight()} 0px 0px 0px`,
      },
    )
  }

  setupListeners () {
    super.setupListeners()

    if (this.triggerElement) {
      this.observer.observe(this.triggerElement)
    } else {
      this.setVisible(true)
    }
  }

  /** @type {IntersectionObserverCallback} */
  handleObservation (entries) {
    const hasVisibleTarget = entries.some(entry => entry.isIntersecting)

    this.setVisible(!hasVisibleTarget)
  }

  /** @param {boolean} visible */
  setVisible (visible) {
    this.setAttribute('aria-hidden', !visible)
  }

  get triggerElement () {
    return getElement(`#${this.getAttribute('hide-target')}`)
  }
}

if (!window.customElements.get('pinned-content')) {
  window.customElements.define('pinned-content', PinnedContent)
}
